'use client';

import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useEffectOnce } from 'react-use';

import { FormattedMessage } from '@flipster/i18n';
import { Explain } from '@flipster/react/design-utils/explain';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { NumberInputWithSuffix } from '../../input/number-input-with-suffix';
import { positionCloseModalBunja } from '../state';

export const LimitClosePrice = () => {
  const t = useTranslations();
  const { positionAtom, limitPriceAtom, isExceedLiqPriceAtom, bboPriceAtom, instrumentAtom } =
    useBunja(positionCloseModalBunja);
  const [limitPrice, setLimitPrice] = useAtom(limitPriceAtom);
  const position = useAtomValue(positionAtom);
  const bboPrice = useAtomValue(bboPriceAtom);
  const isExceedLiqPrice = useAtomValue(isExceedLiqPriceAtom);
  const instrument = useAtomValue(instrumentAtom);

  useEffectOnce(() => {
    if (!position) return;
    setLimitPrice(bboPrice);
  });

  return (
    <div className={stack({ p: 16, bg: 'background.default.level-1', borderRadius: 8, gap: 8 })}>
      <div className={css({ textStyle: 'Text/M/Strong' })}>{t('Trade.r251111.Limit_close_price')}</div>
      <div className={css({ textStyle: 'Title/M/Monospace' })}>
        <NumberInputWithSuffix
          value={limitPrice}
          precision={instrument.pricePrecision}
          onChange={(value) => setLimitPrice(value || '0')}
        />
      </div>
      {isExceedLiqPrice && (
        <Explain.Warning css={{ '& svg': { display: 'none' } }}>
          <FormattedMessage id='Trade.r251208.Exceed_liquidation_price_error' />
        </Explain.Warning>
      )}
    </div>
  );
};
